import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'MaxAccountNumberSign'
})
export class MaxAccountNumberSignPipe implements PipeTransform {
    transform(num: any, sign: string, area: string): any {
        if (num !== '0' && !num?.includes('-')) {
            if (area === 'inner') {
                return sign + num;
            } else {
                return num + sign;
            }
        }
        return num;
    }
}
